import { useContext, useEffect, useState, type FC } from "react";
import MainLayout from "../components/MainLayout";
import { Button, Checkbox, IconButton } from "rsuite";
import { LoadingContext } from "../contexts/LoadingContext";
import { SearchContext } from "../contexts/SearchContext";
import {
  createWarehouse,
  deleteWarehouse,
  getWarehouses,
  updateWarehouse,
} from "../services/inventory/WarehouseApi";
import { errorToast } from "../utils/helper-ui";
import { PaginationResponse } from "../objects/pagination";
import { getPagination } from "../utils/helper";
import { Warehouse } from "../models/inventory/warehouse";
import { Table, Pagination } from "rsuite";
import PlusIcon from "@rsuite/icons/Plus";
import { BsTrash3 } from "react-icons/bs";
import WarehouseForm from "../components/features/inventory/WarehouseForm";
const { Column, HeaderCell, Cell } = Table;
interface WarehousePageProps {}

const WarehousePage: FC<WarehousePageProps> = ({}) => {
  const { search, setSearch } = useContext(SearchContext);
  const { isLoading, setIsLoading } = useContext(LoadingContext);
  const [mounted, setMounted] = useState(false);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(30);
  const [pagination, setPagination] = useState<PaginationResponse>();
  const [warehouses, setWarehouses] = useState<Warehouse[]>([]);
  const [modalFormOpen, setModalFormOpen] = useState(false);
  const [selectedWarehouse, setSelectedWarehouse] = useState<Warehouse>();

  const [checkedKeys, setCheckedKeys] = useState<string[]>([]);
  let checked = false;
  let indeterminate = false;

  if (checkedKeys.length === warehouses.length) {
    checked = true;
  } else if (checkedKeys.length === 0) {
    checked = false;
  } else if (checkedKeys.length > 0 && checkedKeys.length < warehouses.length) {
    indeterminate = true;
  }

  const handleCheckAll = (
    value: any,
    checked: boolean,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const keys = checked ? warehouses.map((item) => item.id) : [];
    setCheckedKeys(keys);
  };
  const handleCheck = (
    value: any,
    checked: boolean,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const keys = checked
      ? [...checkedKeys, value as string]
      : checkedKeys.filter((item) => item !== (value as string));
    setCheckedKeys(keys);
  };
  useEffect(() => {
    setMounted(true);

    return () => {
      setMounted(false);
    };
  }, []);

  useEffect(() => {
    if (!mounted) return;
    fetchData();
  }, [mounted, search, page, size]);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const res = await getWarehouses({ page, size, search });
      const resJson = await res.json();
      //   console.log(data);
      setWarehouses((prev) => [...prev, ...resJson.data.items]);
      setPagination(getPagination(resJson.data));
    } catch (error) {
      errorToast(`${error}`);
    } finally {
      setIsLoading(false);
    }
  };

  const removeWarehouse = async (warehouse: Warehouse) => {
    try {
      setIsLoading(true);
      if (
        window.confirm(
          `Are you sure you want to delete warehouse with name ${warehouse.name}?`
        )
      ) {
        await deleteWarehouse(warehouse.id!);
        fetchData();
      }
    } catch (error) {
      errorToast(`${error}`);
    } finally {
      setIsLoading(false);
    }
  };
  const saveWarehouse = async (warehouse: Warehouse) => {
    try {
      setIsLoading(true);
      if (selectedWarehouse) {
        await updateWarehouse(selectedWarehouse.id!, warehouse);
      } else {
        await createWarehouse(warehouse);
      }
      setModalFormOpen(false);
      setSelectedWarehouse(undefined);
      fetchData();
      setWarehouses([]);
    } catch (error) {
      errorToast(`${error}`);
    } finally {
      setIsLoading(false);
    }
  };
  const renderHeader = () => (
    <div className="flex flex-row justify-between items-center px-2">
      <h1 className="text-2xl font-semibold">Warehouse</h1>
      {/* button */}
      <div>
        <IconButton
          size="sm"
          appearance="primary"
          color="green"
          icon={<PlusIcon />}
          onClick={() => setModalFormOpen(true)}
        >
          Create Warehouse
        </IconButton>
      </div>
    </div>
  );
  return (
    <MainLayout header={renderHeader()}>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr>
              <th
                className="px-4 py-2 text-left border bg-gray-50"
                style={{ width: 100 }}
              >
                <Checkbox
                  inline
                  checked={checked}
                  indeterminate={indeterminate}
                  onChange={handleCheckAll}
                />
              </th>
              <th className="px-4 py-2 text-left border bg-gray-50">Name</th>
              <th className="px-4 py-2 text-left border bg-gray-50">Company</th>
              <th className="px-4 py-2 text-left border bg-gray-50">Code</th>
              <th className="px-4 py-2 text-left border bg-gray-50">
                Description
              </th>
              <th className="px-4 py-2 text-left border bg-gray-50">Address</th>

              <th className="px-4 py-2 text-left border bg-gray-50">Action</th>
            </tr>
          </thead>
          <tbody>
            {warehouses.map((rowData, i) => (
              <tr key={rowData.id}>
                 <td className="px-4 py-2 border">
                  <Checkbox
                    value={rowData.id}
                    inline
                    onChange={handleCheck}
                    checked={checkedKeys.some((item) => item === rowData.id)}
                  />
                  {i + 1}
                </td>
             
                <td
                  className="px-4 py-2 border hover:underline cursor-pointer font-semibold"
                  onClick={() => {
                    setSelectedWarehouse(rowData);
                    setModalFormOpen(true);
                  }}
                >
                  {rowData.name}
                </td>
                <td className="px-4 py-2 border">{rowData.company?.name}</td>
                <td className="px-4 py-2 border">{rowData.code}</td>
                <td className="px-4 py-2 border">
                  {rowData.description ?? "-"}
                </td>
                <td className="px-4 py-2 border">{rowData.address ?? "-"}</td>

                <td className="px-4 py-2 border">
                  <BsTrash3
                    className="text-red-500 hover:text-red-800"
                    size={16}
                    onClick={() => removeWarehouse(rowData)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {!pagination?.last && (
        <div className="flex justify-center my-2">
          <Button
            onClick={() => {
              setPage((pagination?.page ?? 0) + 1);
            }}
          >
            Load more
          </Button>
        </div>
      )}
      {/* <Table minHeight={700} data={warehouses} onRowClick={(data, i) => {}}>
        <Column width={50} align="center" fixed>
          <HeaderCell style={{ padding: 0 }}>
            <div style={{ lineHeight: "40px" }}>
              <Checkbox
                inline
                checked={checked}
                indeterminate={indeterminate}
                onChange={handleCheckAll}
              />
            </div>
          </HeaderCell>
          <Cell style={{ padding: 0 }}>
            {(rowData) => (
              <div style={{ lineHeight: "46px" }}>
                <Checkbox
                  value={rowData.id}
                  inline
                  onChange={handleCheck}
                  checked={checkedKeys.some((item) => item === rowData.id)}
                />
              </div>
            )}
          </Cell>
        </Column>
        <Column width={70} align="center" fixed>
          <HeaderCell>No</HeaderCell>
          <Cell>
            {(rowData) => (
              <div>
                {(page - 1) * size +
                  warehouses.indexOf(rowData as Warehouse) +
                  1}
              </div>
            )}
          </Cell>
        </Column>

        <Column width={200} resizable fixed>
          <HeaderCell>Name</HeaderCell>
          <Cell>
            {(rowData) => (
              <div
                className="hover:underline cursor-pointer font-semibold "
                onClick={() => {
                  setSelectedWarehouse(rowData as Warehouse);
                  setModalFormOpen(true);
                }}
              >
                {rowData.name}
              </div>
            )}
          </Cell>
        </Column>

        <Column width={200} resizable>
          <HeaderCell>Company</HeaderCell>
          <Cell>{(rowData) => <div>{rowData.company?.name}</div>}</Cell>
        </Column>
        <Column width={200} resizable>
          <HeaderCell>Code</HeaderCell>
          <Cell>{(rowData) => <div>{rowData.code}</div>}</Cell>
        </Column>

        <Column width={200} resizable>
          <HeaderCell>Description</HeaderCell>
          <Cell>{(rowData) => <div>{rowData.description ?? "-"}</div>}</Cell>
        </Column>

        <Column width={200} resizable>
          <HeaderCell>Address</HeaderCell>
          <Cell>{(rowData) => <div>{rowData.address ?? "-"}</div>}</Cell>
        </Column>

        <Column width={150} resizable>
          <HeaderCell>Phone</HeaderCell>
          <Cell>{(rowData) => <div>{rowData.phone ?? "-"}</div>}</Cell>
        </Column>

        <Column width={150} resizable>
          <HeaderCell>Contact Person</HeaderCell>
          <Cell>{(rowData) => <div>{rowData.contact_person ?? "-"}</div>}</Cell>
        </Column>

        <Column width={150} resizable>
          <HeaderCell>Contact Position</HeaderCell>
          <Cell>
            {(rowData) => <div>{rowData.contact_position ?? "-"}</div>}
          </Cell>
        </Column>

        <Column width={150} resizable>
          <HeaderCell>Contact Title</HeaderCell>
          <Cell>{(rowData) => <div>{rowData.contact_title ?? "-"}</div>}</Cell>
        </Column>

        <Column width={200} resizable>
          <HeaderCell>Contact Note</HeaderCell>
          <Cell>{(rowData) => <div>{rowData.contact_note ?? "-"}</div>}</Cell>
        </Column>
        <Column width={200} resizable>
          <HeaderCell>Action</HeaderCell>
          <Cell>
            {(rowData) => (
              <BsTrash3
                className="text-red-500 hover:text-red-800"
                size={16}
                onClick={() => removeWarehouse(rowData as Warehouse)}
              />
            )}
          </Cell>
        </Column>
      </Table> */}
      {/* <div style={{ padding: 20 }}>
        <Pagination
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          maxButtons={5}
          size="xs"
          layout={["total", "-", "limit", "|", "pager", "skip"]}
          total={pagination?.total ?? 0}
          limitOptions={[10, 30, 50]}
          limit={pagination?.size}
          activePage={pagination?.page}
          onChangePage={setPage}
          onChangeLimit={setSize}
        />
      </div> */}
      <WarehouseForm
        warehouse={selectedWarehouse}
        open={modalFormOpen}
        onClose={() => {
          setModalFormOpen(false);
          setSelectedWarehouse(undefined);
        }}
        onSubmit={saveWarehouse}
      />
    </MainLayout>
  );
};
export default WarehousePage;
